import { Injectable } from '@angular/core';
import { RestService, Rest, ABP } from '@abp/ng.core';
import { AppModuleManagement } from '../models';
import { Observable } from 'rxjs';
import { GetUsersByTenantRequest, UserData, UserByTenantResponse } from '../models';

@Injectable({
    providedIn: 'root',
})
export class IdentityUserExtensionService {
    apiName = 'TerminalManagement';
    constructor(private rest: RestService) { }

    usersByTenant(params: GetUsersByTenantRequest) {
        const request: Rest.Request<null> = {
            method: 'GET',
            url: '/api/TerminalManagement/IdentityUser/Extensions/users-by-tenant',
            params,
        };

        return this.rest.request<null, UserByTenantResponse>(request, { apiName: this.apiName });
    }
}